export default __webpack_public_path__ + "static/media/about-oscer-character-mission.dfe2daee.svg";